export default __webpack_public_path__ + "static/media/Masking.8175630b.jpg";